export default "__VITE_ASSET__CjN$8Pnp__"